import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["options", "value"],
  _excluded2 = ["indicator"];
import { memo, useMemo } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectWithIndicator = props => {
  const {
      options,
      value
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const normalizedOptions = useMemo(() => {
    if (!options) {
      return options;
    }
    return options.map(option => {
      // If this is a select with nested options, we don't try to modify them
      // We don't have a use case for indicators on nested options at the moment
      // And the new Trellis Select may not support nested options
      if ('options' in option) {
        return option;
      }
      const {
          indicator
        } = option,
        restOption = _objectWithoutPropertiesLoose(option, _excluded2);
      return Object.assign({}, restOption, {
        avatar: restOption.avatar || indicator || undefined
      });
    });
  }, [options]);

  // This fixes a bug caused by a quirk of the Select component: if the value is undefined,
  // the Select thinks the consumer is using it uncontrolled and will change the value
  // when another option is selected, even if the `value` it receives is still undefined.
  // This caused a bug with the conditional properties panel: if the initial value was
  // undefined, and an option was selected that opened the panel and you close out of it,
  // onChange is not called and the value is still undefined but the Select showed the selected option.
  // So we normalize undefined to an empty string here.
  const fixedValue = value === undefined ? '' : value;
  return /*#__PURE__*/_jsx(Select, Object.assign({
    options: normalizedOptions
  }, restProps, {
    value: fixedValue
  }));
};
export default /*#__PURE__*/memo(SelectWithIndicator);